import axios from "axios";
import { idText } from "typescript";
import { getToken, getUser } from "../Utils/Common";
import { getAPICall, postAPICall, postAPICall2, putAPICall, deleteAPICall } from "./axiosMethodCalls";


export const getAllRemarks = async () => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "remarks/getAll"
        );
        return { data: response };
    } catch (error) {
        return { error: error.response };
    }
};

export const createRemarks = async (data) => {
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "remarks/create", {
                requester: getUser(),
                token: getToken(),
                name: data.name,
            }
        );
        return { data: response };
    } catch (error) {
        return { error: error.response };
    }
};

export const updateRemarks = async (data) => {
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "remarks/update/" + data.id,{
                requester: getUser(),
                token: getToken(),
                name: data.name,
            }
        );
        return { data: response };
    } catch (error) {
        return { error: error.response };
    }
};


//GET
export const deleteRemarks = async (id) => {
    try {
        const params = new URLSearchParams();
        params.append('updated_by',getUser())
        params.append('token',getToken())

        const response = await putAPICall(
            process.env.REACT_APP_LINK + "remarks/delete/" + id,
            params
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};